
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 33"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75 21.656a8.632 8.632 0 01-6.01-2.416 8.129 8.129 0 01-2.49-5.834V9.281c0-.547.224-1.071.622-1.458a2.158 2.158 0 011.503-.604h12.75c.564 0 1.104.217 1.503.604.398.387.622.911.622 1.458v4.125a8.129 8.129 0 01-2.49 5.834 8.632 8.632 0 01-6.01 2.416zM8.5 7.219V1.03M17 7.219V1.03","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.75 21.656v4.125c0 1.094.448 2.143 1.245 2.917A4.316 4.316 0 0017 29.906a4.316 4.316 0 003.005-1.208 4.065 4.065 0 001.245-2.917c0-1.094.448-2.143 1.245-2.917a4.316 4.316 0 013.005-1.208v0c1.127 0 2.208.435 3.005 1.208a4.065 4.065 0 011.245 2.917v6.188M10.625 11.344h4.25","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    